import { InfoWindow } from "@vis.gl/react-google-maps"
import { HostServiceCard } from "./presentationals/HostServiceCard"

interface HostServiceDetailWindowProps {
    hostService: any
    spyId?: number
    index: number
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
    onClose: (event: any) => void
}

export const HostServiceDetailWindow = (props: HostServiceDetailWindowProps): JSX.Element => {
    const {
        hostService,
        spyId,
        onStartPropertySpy,
        onStopPropertySpy,
        onClose,
        index
    } = props

    const position = {
        lat: hostService?.latitude,
        lng: hostService?.longitude
    }

    const handleClose = (event: any) => {
        onClose?.(event)
    }

    return (
        <InfoWindow position={position} headerDisabled minWidth={390} >
            <HostServiceCard
                hostService={hostService}
                spyId={spyId}
                onStartPropertySpy={onStartPropertySpy}
                onStopPropertySpy={onStopPropertySpy}
                onClose={handleClose}
                index={index}
            />
        </InfoWindow>
    )
}